<template>
  <div>
    <div>

      <div  v-if="!tools || !tools.length">
        No Treatments
      </div>

      <div v-if="tools && tools.length" class="form-group">
        <select
          class="form-control custom-select"
          id="toolSelector"
          name="toolSelector"
          v-model="toolIdValue"
          @change="onToolChanged"
        >
          <option
            :key="tool.id"
            :value="tool.id"
            :class="{ 'ignored-tool': tool.ignoreTool }"
            v-for="tool in tools"
          >
            {{ tool.name }}
          </option>
        </select>
      </div>
    </div>

    <b-form-checkbox v-if="toolId" id="ignoreTool" v-model="ignoreToolValue">
      Exclude this Treatment from computation
    </b-form-checkbox>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Treatment } from "@/entities/Treatment";
import { ToolOpinion } from "@/entities/ToolOpinion";

@Component
export default class AppToolSelector extends Vue {
  toolIdValue: number | null = null;
  ignoreToolValue: boolean = false;

  @Prop()
  branchId!: number;

  @Prop()
  toolId!: number | null;

  @Prop()
  toolOpinion: ToolOpinion | null = null;

  get tools(): Treatment[] {
    return this.$store.getters["tool/getAllTools"];
  }

  @Watch("branchId")
  async onBranchChanged(val: number) {
    await this.$store.dispatch("tool/getToolsByBranchId", { branchId: val });
    this.toolIdValue =
      this.tools && this.tools.length > 0 ? this.tools[0].id : null;
    this.ignoreToolValue =
      this.tools && this.tools.length > 0 ? this.tools[0].ignoreTool : false;
  }

  @Watch("toolIdValue")
  onToolChanged() {
    this.$emit("input", this.toolIdValue);
    this.ignoreToolValue =
      this.tools.find(x => x.id === this.toolId)?.ignoreTool || false;
  }

  @Watch("ignoreToolValue")
  onIgnoreToolChanged() {
    if (this.toolOpinion != null) {
      this.toolOpinion.ignoreTool = this.ignoreToolValue;
    }
  }

  async created() {
    await this.$store.dispatch("tool/getToolsByBranchId", {
      branchId: this.branchId
    });

    if (this.tools && this.tools.length > 0) {
      this.toolIdValue = this.tools[0].id;
      this.ignoreToolValue = this.tools[0].ignoreTool;
    }

    if (
      this.toolId &&
      this.tools &&
      this.tools.some(x => x.id === this.toolId)
    ) {
      this.toolIdValue = this.toolId;
      this.ignoreToolValue =
        this.tools.find(x => x.id === this.toolId)?.ignoreTool || false;
    }
  }
}
</script>

<style scoped>
.ignored-tool {
  color: darkgrey;
}
</style>
